// src/pages/Checkout.js
import React from 'react';
import { Container, Typography, Box, Button, List, ListItem, ListItemText, Divider } from '@mui/material';


const Checkout = ({ cart }) => {
  const totalPrice = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <Container>
      <Box sx={{ textAlign: 'center', padding: '50px 0' }}>
        <Typography variant="h2" gutterBottom>Finalizar Compra</Typography>
      </Box>

      <List>
        {cart.map((item) => (
          <ListItem key={item.id}>
            <ListItemText primary={`${item.name} x${item.quantity}`} secondary={`Precio: $${item.price * item.quantity}`} />
          </ListItem>
        ))}
      </List>

      <Divider sx={{ margin: '20px 0' }} />

      <Typography variant="h5">Total: ${totalPrice}</Typography>

      <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
        <Button variant="contained" color="primary">Proceder al Pago</Button>
      </Box>
    </Container>
  );
};

export default Checkout;
